import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CareGap`;

const getPatientCareGaps = async (cipId, page = 1, pageSize = 100) => {
  try {
    const response = await axios.get(`${API_URL}/patient/${cipId}`, {
      params: { page, pageSize },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching patient care gaps:", error);
    throw error;
  }
};

export default getPatientCareGaps;
